import React, { useMemo } from 'react'
import { getNextWeekStart } from '../../../../common/dateUtils'
import { LinkButton } from '../../../../components/Button/LinkButton'
import { useCrossClientRemainingQueries } from './hooks'

export const CrossClientLimit = () => {
  const { maxCcQueriesPerWeek, remainingCcQueriesPerWeek, quotaLoading } = useCrossClientRemainingQueries()

  const { formattedNextWeekStart, daysUntilNextWeek } = useMemo(() => {
    const { nextWeekStart, daysUntilNextWeek } = getNextWeekStart()
    const formattedNextWeekStart = nextWeekStart.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
    })
    return { formattedNextWeekStart, daysUntilNextWeek }
  }, [])

  if (quotaLoading) {
    return <div className='skeleton pt-2 zocks-border-0.5' style={{ width: '100%', height: '1rem' }} />
  }

  if (remainingCcQueriesPerWeek === 0) {
    return (
      <>
        <div className='d-flex gap-2 mt-2 py-1 px-2 zocks-bg-color-danger-background zocks-text-danger-200 zocks-border-0.5 align-items-center align-self-center'>
          <i className='bi bi-ban fs-6' />
          <div className='paragraph-small'>
            Monthly limit reached • Resets in {daysUntilNextWeek} day{daysUntilNextWeek === 1 ? '' : 's'} ({formattedNextWeekStart})
          </div>
        </div>
        <CrossClientLimitMoreSearches />
      </>
    )
  }

  if (remainingCcQueriesPerWeek < 10) {
    return (
      <>
        <div className='d-flex gap-2 mt-2 py-1 px-2 zocks-bg-color-warning zocks-border-0.5 align-items-center align-self-center'>
          <i className='bi bi-exclamation-triangle fs-6' />
          <div className='paragraph-small'>
            {remainingCcQueriesPerWeek} searches left • Resets in {daysUntilNextWeek} day{daysUntilNextWeek === 1 ? '' : 's'} ({formattedNextWeekStart})
          </div>
        </div>
        <CrossClientLimitMoreSearches />
      </>
    )
  }

  return (
    <div className='paragraph-small zocks-text-gray-600'>
      {remainingCcQueriesPerWeek} of {maxCcQueriesPerWeek} searches remaining • Resets {formattedNextWeekStart}
    </div>
  )
}

const CrossClientLimitMoreSearches = () => {
  return (
    <div className='d-flex gap-1 align-items-center align-self-center'>
      <span className='paragraph-small medium'>Need more searches? </span>
      <span className='paragraph-small'>Email us at</span>
      <LinkButton to='mailto:support@zocks.io' className='p-0 paragraph-small zocks-text-primary'>
        support@zocks.io
      </LinkButton>
    </div>
  )
}
